































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AsideMenuItem extends Vue {
  @Prop({
    type: Object,
    default: null,
  })
  public item!: any;

  public isDropdownActive = false;

  public get componentIs(): string {
    return this.item.to ? 'router-link' : 'a';
  }
  public get hasDropdown(): boolean {
    return !!this.item.menu;
  }
  public get dropdownIcon(): string {
    return this.isDropdownActive ? 'minus' : 'plus';
  }
  public get itemTo(): string | null {
    return this.item.to ? this.item.to : null;
  }
  public get itemHref(): string | null {
    return this.item.href ? this.item.href : null;
  }

  public menuClick(): void {
    this.$emit('menu-click', this.item);

    if (this.hasDropdown) {
      this.isDropdownActive = !this.isDropdownActive;
    }
  }
}
